import logo from './logo.svg';
import { Route, Routes } from "react-router-dom";
import React from "react";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard"
import { ProtectedRoute } from "./components/ProtectedRoute";
import { SalesProtectedRoute } from "./components/SalesProtectedRoute";
import { AdminProtectedRoute } from "./components/AdminProtectedRoute";
import ViewUserRGAList from "./pages/ViewUserRGAList";
import ViewAllRGAList from "./pages/ViewAllRGAList";
import ViewRGA from "./pages/ViewRGA";
import Register from "./pages/Register";
import ViewUserRGA from "./pages/ViewUserRGA";
import RequestResetPassword from "./pages/RequestResetPassword";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <Routes>
        <Route exact path='/' element={<Login />}></Route>
        <Route exact path='/register' element={<Register />}></Route>
        <Route exact path='/request_password_reset' element={<RequestResetPassword />}></Route>
        <Route path='/reset_password/:tokenId' element={<ResetPassword />}></Route>
        <Route exact path='/dashboard' element={<ProtectedRoute><Dashboard /></ProtectedRoute>}></Route>
        <Route exact path='/view_user_rgas' element={<ProtectedRoute><ViewUserRGAList /></ProtectedRoute>}></Route>
        <Route path='/view_rga' element={<ProtectedRoute><ViewRGA /></ProtectedRoute>}></Route>
        <Route path='/view_user_rga' element={<ProtectedRoute><ViewUserRGA /></ProtectedRoute>}></Route>
        <Route exact path='/view_all_rgas' element={<SalesProtectedRoute><ViewAllRGAList /></SalesProtectedRoute>}></Route>
        <Route exact path='/admin_view_all_rgas' element={<AdminProtectedRoute><ViewAllRGAList /></AdminProtectedRoute>}></Route>
    </Routes>
);
}

export default App;
